import { render, staticRenderFns } from "./JustLogo.vue?vue&type=template&id=766056e3"
import script from "./JustLogo.vue?vue&type=script&lang=js"
export * from "./JustLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports